module.exports = "/images/vendor/flag-icon-css/flags/1x1/ve.svg?9f23d9626b92963d5502674c91463b51";